$(document).ready( function() {

	var $nav = $('.main-nav');
	var $burger = $nav.find('.main-nav__burger');
	var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

	// ---------- Dropdown account / lingua ----------
	// Hover sui dispositivi con mouse, click/tap ovunque, Esc e click esterno chiudono.
	function setDropdown($dropdown, open) {
		$dropdown.toggleClass('is-open', open);
		$dropdown.children('button').attr('aria-expanded', open ? 'true' : 'false');
	}

	function closeDropdowns($except) {
		$nav.find('[data-nav-dropdown].is-open').not($except || $()).each(function() {
			setDropdown($(this), false);
		});
	}

	$nav.find('[data-nav-dropdown]').each(function() {
		var $dropdown = $(this);

		$dropdown.children('button').on('click', function(e) {
			e.stopPropagation();
			closeDropdowns($dropdown);
			// col mouse il menu è già aperto dall'hover: il click non deve richiuderlo
			setDropdown($dropdown, canHover || !$dropdown.hasClass('is-open'));
		});

		if (canHover) {
			$dropdown.on('mouseenter', function() {
				closeDropdowns($dropdown);
				setDropdown($dropdown, true);
			}).on('mouseleave', function() {
				setDropdown($dropdown, false);
			});
		}
	});

	// ---------- Menu mobile ----------
	function setPanel(open) {
		$nav.toggleClass('is-menu-open', open);
		$burger.attr('aria-expanded', open ? 'true' : 'false');
	}

	$burger.on('click', function(e) {
		e.stopPropagation();
		closeDropdowns();
		setPanel(!$nav.hasClass('is-menu-open'));
	});

	$(document).on('click', function(e) {
		if (!$(e.target).closest('.main-nav__menu, .main-nav__panel').length) {
			closeDropdowns();
			setPanel(false);
		}
	});

	$(document).on('keydown', function(e) {
		if (e.key === 'Escape') {
			closeDropdowns();
			if ($nav.hasClass('is-menu-open')) {
				setPanel(false);
				$burger.trigger('focus');
			}
		}
	});

	// ---------- Header sticky ----------
	// Scrollando giù l'header scorre via con la pagina, scrollando su torna fisso in alto.
	var el = $(window),
		lastY = el.scrollTop();

	el.on( 'scroll', function() {

		var currY = el.scrollTop(),
			y = (currY > lastY) ? 'down' : ((currY === lastY) ? 'none' : 'up');

		if( y == 'up' && !$nav.hasClass('sticky') ) {

			$nav.css( {"position":"", 'top':""} );
			$nav.addClass('sticky');

			$nav.css( {'top':-$nav.height()} );
			$nav.animate( {'top':0}, 200 );

		} else if( y == 'down' && $nav.hasClass('sticky') ) {

			closeDropdowns();
			setPanel(false);
			$nav.removeClass('sticky');
			$nav.css( {'top':$(document).scrollTop(), 'position':'absolute'} );

		}

		lastY = currY;

	} );

	// ---------- Preferenze cookie (link nel footer) ----------
	$('.js-cookie-preferences').on('click', function(e) {
		e.preventDefault();
		$('.cookie-container').fadeIn();
	});

} );
